import angular from 'angular';

import ProgressBarComponent from './progress-bar.component';
export default angular.module('ttb.core.progressBar', [])
    .component('progressBar', ProgressBarComponent)
    .name;


// WEBPACK FOOTER //
// ./components/progress-bar/index.js